import React from 'react';
import ReactDOM from 'react-dom';

import App from './App';
import './index.css';
import * as serviceWorker from './serviceWorker';
import './languages';
import { loadConfig, getConfigAll, getConfig } from './config';
import { createAxiosClient } from './apis/api';

loadConfig().then(() => {
  const conf = getConfigAll();
  createAxiosClient(getConfig('REACT_APP_API_URL'));
  ReactDOM.render(<App configs={conf} />, document.getElementById('root'));
});

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
